var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-editor"},[_c('editor',{ref:"editor",attrs:{"init":_vm.init,"disabled":_vm.disabled},on:{"onInit":_vm.lodingFinish,"onClick":_vm.onClick,"onBlur":_vm.onblur},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }